/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import Types from '../constants/actionTypes';

const initialState = {
  attachments: [],
  isFetching: false,
  isUploading: false,
  thumbnails: {},
  downloadUrl: {},
  counting: 0
};

const attachmentReducer = (state = initialState, action) => {
  switch (action.type) {
    case Types.REQUEST_ATTACHMENT:
      return {
        ...state,
        isFetching: true,
        isUploading: false
      };
    case Types.RECEIVE_ATTACHMENTS:
      return {
        ...state,
        isFetching: false,
        isUploading: state.counting !== 0,
        attachments: action.attachments
      };
    case Types.RECEIVE_ATTACHMENTS_ERROR:
      return {
        ...state,
        isFetching: false,
        isUploading: false
      };
    case Types.RECEIVE_THUMBNAIL:
      return {
        ...state,
        isFetching: false,
        isUploading: false,
        thumbnails: { ...state.thumbnails, ...action.thumbnail }
      };
    case Types.RECEIVE_ATTACHMENT_FILE:
      return {
        ...state,
        isFetching: false,
        isUploading: false,
        downloadUrl: { ...state.downloadUrl, ...action.file }
      };
    case Types.UPLOAD_ATTACHMENT:
      return { ...state, isUploading: true };
    case Types.END_UPLOAD_ATTACHMENT:
      return {
        ...state,
        isUploading: !(state.counting <= 1),
        isFetching: false,
        attachments: action.attachments,
        counting: state.counting > 0 ? state.counting - 1 : 0
      };
    case Types.END_UPLOAD_ATTACHMENT_ERROR:
      return {
        ...state,
        isUploading: !(state.counting <= 1),
        isFetching: false,
        counting: state.counting > 0 ? state.counting - 1 : 0
      };
    case Types.DELETE_ATTACHMENT:
      return { ...state, isFetching: true };
    case Types.END_DELETE_ATTACHMENT:
      return { ...state };
    case Types.SET_ATTACHMENT_COUNTING:
      return { ...state, counting: action.counting };
    case Types.CLEAR_ACTIVE_SPINNER:
      return { ...state, isFetching: false };
    default:
      return state;
  }
};

export default attachmentReducer;
